import { Component, Inject, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MaterialModule } from "@assoanalytics/app/material.module";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

import { StorageService } from "@assoanalytics/app/core/services/storage.service";
import { defaults } from "@assoanalytics/app/app.config";
import { SharedModule } from "../../shared.module";
import { LanguageService } from "../../services/language/language.service";

@Component({
  selector: "app-language-switcher",
  imports: [SharedModule, MaterialModule, ReactiveFormsModule],
  templateUrl: "./language-switcher.component.html",
  styleUrl: "./language-switcher.component.scss",
})
export class LanguageSwitcherComponent implements OnInit {
  form: FormGroup;
  close?: string;

  supportedLanguages = defaults.supportedLanguages;
  languagesOptions = this.translate.getLangs();

  constructor(
    private storageService: StorageService,
    private languageService: LanguageService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<void>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      close?: string;
    },
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      language: new FormControl(
        this.languageService.getCurrentLanguage(),
        Validators.required,
      ),
    });
  }

  onSubmit() {
    this.changeLanguage(this.form.value.language);
  }

  changeLanguage(lang: string): void {
    this.storageService.setLanguage(lang);
    this.closeAction();
    window.location.reload();
  }

  closeAction() {
    return this.dialogRef.close(false);
  }
}
